var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "accordion",
      class: [{ collapsed: _vm.collapsed }, _vm.accordionClasses],
    },
    [
      !_vm.isMultidamageFlow
        ? _c(
            "div",
            {
              staticClass: "accordion__top mg mg--b-4",
              on: {
                click: function ($event) {
                  return _vm.toggleAccordion($event)
                },
              },
            },
            [
              _vm._t("accordionTop"),
              _c("svgicon", {
                staticClass: "svg-legacy",
                attrs: { icon: "arrow_right", width: "18" },
              }),
            ],
            2
          )
        : _vm._e(),
      _vm.isMultidamageFlow
        ? _c(
            "div",
            {
              staticClass: "accordion__top accordion__top--with-options",
              class: {
                buttonDeleteIsVisible: _vm.showDeleteBtn,
                "accordion__top--piece-confirmed": _vm.pieceConfirmed,
              },
              on: { click: _vm.handleMoreOptions },
            },
            [
              _vm._t("accordionTop"),
              !_vm.pieceConfirmed
                ? _c("svgicon", {
                    staticClass: "svg-options",
                    attrs: {
                      icon: "more-vertical",
                      height: "24",
                      width: "auto",
                    },
                  })
                : _vm._e(),
              _vm.pieceConfirmed
                ? _c("svgicon", {
                    staticClass: "svg-confirmed",
                    attrs: { icon: "check-mark", height: "24", width: "auto" },
                  })
                : _vm._e(),
              _c(
                "div",
                {
                  staticClass: "buttonDelete",
                  attrs: { "v-if": _vm.showDeleteBtn },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "containerBtn",
                      on: {
                        click: function ($event) {
                          return _vm.$emit("deletePiece")
                        },
                      },
                    },
                    [
                      _c("svgicon", {
                        staticClass: "icon",
                        attrs: {
                          name: "ico-deletenew",
                          color: "#566473",
                          height: "13",
                          width: "15",
                        },
                      }),
                      _c("p", { staticClass: "text-small gray" }, [
                        _vm._v(_vm._s(_vm.$t("multidamageList.delete"))),
                      ]),
                    ],
                    1
                  ),
                ]
              ),
            ],
            2
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "accordion__bottom" },
        [_vm._t("accordionBottom")],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }